import { render, staticRenderFns } from "./BankSelectionItem.vue?vue&type=template&id=389bb8ba&scoped=true&"
import script from "./BankSelectionItem.vue?vue&type=script&lang=js&"
export * from "./BankSelectionItem.vue?vue&type=script&lang=js&"
import style0 from "./BankSelectionItem.vue?vue&type=style&index=0&id=389bb8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389bb8ba",
  null
  
)

export default component.exports